/**
 * WISHLIST PRODUCT DELETE
 * 
 * module de gestion de la suppression
 * de produit dans la wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
const utils = require('../utils.js').default;

const WLProductDelete = (() => {

    const POPIN_PRODUCT_DELETE = 'popin-delete-product';
    const DOM_PRODUCT_DELETE_POPIN_SHOW = `[data-js-dialog-open="${POPIN_PRODUCT_DELETE}"]`;
    const DOM_PRODUCT_DELETE_POPIN = `[data-js-dialog-id="${POPIN_PRODUCT_DELETE}"]`;
    const DOM_WISHLIST_PRODUCT_DELETE = '.js-wishlist-product-delete';

    /**
     * PRODUCT DELETE
     * @param {event} event 
     */
    const productDelete = (event) => {
        event.preventDefault();
        // récupération des données
        let id = parseInt($(event.currentTarget).data('id'));
        let product = window.WL.getProductData(id);
        let flattenProduct = window.WL.getWishlistFlattenProduct(
            product.ean,
            product.name,
            product.cat ,
            product.price,
            product.quantity
        );
        WL.removeFromWishlist(id).then(() => {
            utils.debug('WL PRODUCT DELETE', {id, product}); 
            utils.dispatchCustomEvent('ANIMATION_PRODUCT_REMOVE', {id});
            utils.dispatchCustomEvent('TRACKERS_WISHLIST_PRODUCT_DELETE',{
                productLabel: product.name,
                productsCount: window.WL.getProductsQuantityTotal(),
                grandTotal: utils.getFormatedPrice(window.WL.getWishlistGrandTotal()),
            });
            utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_REMOVE_FROM_CART', {
                listLabel: window.WL.getCurrentWishlist(),
                listCategory: utils.getContext(),
                products: [flattenProduct]
            });
        });
        popinClose();
    };
    /**
     * PRODUCT DELETE EVENTS
     * 
     * bind des events
     */
    const productDeleteEvents = () => {
        $(DOM_WISHLIST_PRODUCT_DELETE).off().on('click', productDelete);
    };
    /**
     * POPIN CLOSE (func)
     * 
     * Fermeture de la popin creation d'adresse
     */
    const popinClose = () => {
        // fermeture de la popin
        $(`${DOM_PRODUCT_DELETE_POPIN} .popin-close`).trigger('click');
    };
    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     * @param {event} event 
     */
    const popinOpen = (event) => {
        event.preventDefault();
        updateTemplate(event);
        productDeleteEvents();
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     * @param {event} event 
     */
    const updateTemplate = (event) => {
        let data = {
            name: WL.getWishlistName(),
            reference: $(event.currentTarget).data('reference'),
            id: $(event.currentTarget).data('id'),
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: POPIN_PRODUCT_DELETE, data});
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL PRODUCT DELETE', 'initialisation'); 
        // déplacement/copie d'un produit dans une autre liste (si pro/connecté)
        $(DOM_PRODUCT_DELETE_POPIN_SHOW).off().on('click', popinOpen);
    }
    return {init}
})();
export default WLProductDelete;